export default __webpack_public_path__ + "static/media/16418216952.4d2f266c.JPG";